module.exports = __webpack_public_path__ + "static/media/ops_bookmark.c2aacfa7.png";